<template>
  <div class="pb-2">
    <b-navbar toggleable="lg" type="light" variant="light" class="pl-5 pr-5">
      <b-navbar-brand :to="{name: 'home'}">Главная</b-navbar-brand>
      <b-navbar-nav v-if="jwtAccessValid()">
        <b-nav-item-dropdown text="Отчеты" left>
          <b-dropdown-item :to="{name: 'report-finance'}">Сводный отчет по магазину</b-dropdown-item>
          <b-dropdown-item :to="{name: 'report-revenue2'}">Отчет по выручке</b-dropdown-item>
          <b-dropdown-item :to="{name: 'report-collection2'}">Инкассация</b-dropdown-item>
          <b-dropdown-item :to="{name: 'report-total'}">Итоговые показатели</b-dropdown-item>

        </b-nav-item-dropdown>
      </b-navbar-nav>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          
          <b-nav-item-dropdown  v-if="userName" right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <span>{{userName}}</span>
            </template>
            <b-dropdown-item href="#">Профиль</b-dropdown-item>
            <b-dropdown-item @click="userExit()">Выход</b-dropdown-item>
          </b-nav-item-dropdown>
          
          <b-nav-item v-else>
            <b-button v-b-modal.login size="sm" class="my-2 my-sm-0" variant="primary">Вход</b-button>
          </b-nav-item>
        
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-modal id="login" title="Личный кабинет" centered hide-footer>
      <login></login>
    </b-modal>

  </div>  
</template>

<script>
/* eslint-disable no-console */
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
import Login from '@/components/Login.vue'

export default {
  name: 'TopPanel',
  components: {
    Login,
  },

  props: {
  },
  
  mixins: [],
  
  data () {
    return {}       
  },

  computed: {
    ...mapGetters([
      'userName',
      'jwtAccessValid',
    ]),
  },

  methods: {
    ...mapMutations([
      'removeToken',
    ]),

    userExit() {
      const vm = this
      vm.removeToken()
      document.location.reload(true);
    },
  },

}

</script>

<style scoped>
.modal-title, .modal-body {
  text-align: center !important;
}
</style>

